<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="项目列表"
    :width="'824px'"
    :before-close="cancelHandle"
    :destory-on-close="true"
    :append-to-body="true"
    @open="handleInitail"
  >
    <div v-loading="loading">
      <div v-if="!loading && dataList.length === 0" class="no_data">
        <img src="../../../../../assets/img/box@3x.png" />
        <div>暂无商品，请联系商务对接人或者维保客户配置</div>
      </div>
      <project-list
        v-else
        v-for="item in dataList"
        :key="item.id"
        :source="item"
        @modifyStoreUseState="modifyStoreUseState"
      >
        <template slot="footer">
          <el-form class="store-form" label-width="120px">
            <div v-if="item.packageType === 2">
              <el-form-item prop="maxUseAmount" label="最大消费金额:">
                <div style="display: flex">
                  <el-input disabled :value="item.maxUseAmount" />
                  <el-popover
                    style="margin-left: 10px"
                    placement="top-start"
                    trigger="hover"
                    content="当值为0时则不限金额"
                  >
                    <i class="el-icon-info" slot="reference"></i>
                  </el-popover>
                </div>
              </el-form-item>
              <el-form-item prop="maxUseTime" label="最大消费次数:">
                <div style="display: flex">
                  <el-input disabled :value="item.maxUseTime" />
                  <el-popover
                    style="margin-left: 10px"
                    placement="top-start"
                    trigger="hover"
                    content="当值为0时则不限次数"
                  >
                    <i class="el-icon-info" slot="reference"></i>
                  </el-popover>
                </div>
              </el-form-item>
              <el-form-item prop="maxSingleUseAmount" label="最大单次消费金额:">
                <div style="display: flex">
                  <el-input disabled :value="item.maxSingleUseAmount" />
                  <el-popover
                    style="margin-left: 10px"
                    placement="top-start"
                    trigger="hover"
                    content="当值为0时则不限金额"
                  >
                    <i class="el-icon-info" slot="reference"></i>
                  </el-popover>
                </div>
              </el-form-item>
              <el-form-item prop="expireMonth" label="有效期:">
                <el-input disabled :value="item.expireMonth" />
              </el-form-item>
            </div>
            <el-form-item prop="name1" label="套餐可使用门店:">
              <el-tag
                type="info"
                v-for="child in item.businesses"
                :key="child.businessId"
                >{{ child.businessName }}</el-tag
              >
            </el-form-item>
          </el-form>
        </template>
      </project-list>
    </div>

    <div slot="footer">
      <div class="mt16" style="text-align: center">
        <el-button size="small" @click="cancelHandle">取消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="handleOK"
          :disabled="changeIds.length === 0"
          >确认</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import projectList from './projectList/projectList.vue'
import { listByCollaborationApi, projectUsageChangeApi } from '../services'

export default {
  name: 'projectListDialog',
  components: {
    projectList,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      dataList: [],
      changeIds: [],
    }
  },
  methods: {
    // dialog 初始化函数
    handleInitail() {
      this.getListByCollaboration()
    },
    // dialog ok
    handleOK() {
      this.setProjectUsageChangeApi()
    },
    // dialog cancel
    cancelHandle() {
      this.changeIds = []
      this.dataList = []
      this.$emit('close')
    },
    modifyStoreUseState(source) {
      const index = this.changeIds.findIndex((child) => child.id === source.id)
      if (index > -1) {
        this.changeIds[index].useState =
          source.useState === 0 || source.useState === 2 ? 1 : 0
      } else {
        this.changeIds.push({
          id: source.id,
          useState: source.useState === 0 || source.useState === 2 ? 1 : 0,
        })
      }

      this.dataList = this.dataList.map((child) => {
        if (child.id === source.id) {
          child.useState = child.useState === 0 || child.useState === 2 ? 1 : 0
        }
        return child
      })
    },
    async getListByCollaboration() {
      if (this.id === '') return
      this.loading = true
      listByCollaborationApi({ id: this.id })
        .then(({ code, data }) => {
          if (code === 1) {
            if (data.contents) {
              data.contents = JSON.parse(data.contents)
            }
            this.dataList = data || []
            if (this.dataList.length === 0) {
              this.$message.error('暂无商品，请联系商务对接人或者维保客户配置')
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async setProjectUsageChangeApi() {
      const { code, msg } = await projectUsageChangeApi({
        changeIds: this.changeIds,
      })
      if (code === 1) {
        this.$message.success('操作成功')
        this.cancelHandle()
      } else {
        this.$message.error(msg)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.store-form {
  margin-top: 10px;
  width: 70%;
}
::v-deep(.el-dialog__body) {
  height: calc(70vh - 120px);
  overflow-y: auto;
}
.no_data{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
  >img {
    display: block;
    width: 200px;
    height: 100px;
    margin-bottom: 20px;
  }
}
</style>
